export default __webpack_public_path__ + "static/media/GR6 2A-4C-2EC.77dd922e.jpg";